import axiosInstance from './axios.service';

/** Admin live draw ("sorteo en vivo") API. */
const sorteoEnVivoService = {
  getRifas: async () => {
    const { data } = await axiosInstance.get('/api/sorteo-en-vivo/rifas');
    return data;
  },

  getDrawState: async sorteoId => {
    const { data } = await axiosInstance.get(`/api/sorteo-en-vivo/sorteos/${sorteoId}`);
    return data;
  },

  drawPremio: async premioId => {
    const { data } = await axiosInstance.post(`/api/sorteo-en-vivo/premios/${premioId}/sortear`);
    return data;
  },

  resetPremio: async premioId => {
    const { data } = await axiosInstance.post(`/api/sorteo-en-vivo/premios/${premioId}/reset`);
    return data;
  },
};

export default sorteoEnVivoService;
